import { isProduction } from '../../../constants'
import LogRocket from 'logrocket'

export function initLogRocket(id: string, email?: string, name?: string) {
	isProduction &&
		LogRocket.identify(id, {
			email: email || '',
			name: name || ''
		})
}
